import { TableRowData } from '../../joorPayOrders.types'
import SendPaymentRequestModal, {
  SendPaymentRequestModalProps,
} from 'features/Orders/Review/modals/SendPaymentRequestModal/SendPaymentRequestModal'
import { formatOrderAddress } from 'features/Orders/Review/utils/addresses.utils'

export function SendPaymentRequestModalContainer({
  selectedOrder,
  setIsOpen,
  onSuccess,
}: Props) {
  const order: PaymentRequestOrder = {
    orderId: selectedOrder.id,
    orderPO: selectedOrder.poNumber,
    retailerId: selectedOrder.retailerId ?? '',
    retailerEmail: selectedOrder.shippingEmail ?? '',
    retailerName: selectedOrder.retailerName,
    webOrderId: selectedOrder.webOrderLookupId,
    brandId: selectedOrder.brandId,
    brandName: selectedOrder.brandName,
    orderCurrency: selectedOrder.currency,
    billingAddress: formatOrderAddress({
      firstAddress: selectedOrder?.billingFirstAddress,
      secondAddress: selectedOrder?.billingSecondAddress,
      country: selectedOrder?.billingCountry,
      city: selectedOrder?.billingCity,
      zip: selectedOrder?.billingZip,
    }),
  }

  return (
    <SendPaymentRequestModal
      isOpen
      setIsOpen={setIsOpen}
      onSuccess={onSuccess}
      {...order}
    />
  )
}

type Props = {
  selectedOrder: TableRowData
  setIsOpen: (open: boolean) => void
  onSuccess?: (updatedIds: string[]) => void
}

type PaymentRequestOrder = Omit<
  SendPaymentRequestModalProps,
  'isOpen' | 'setIsOpen'
>
